import { BrowserRouter, Routes, Route } from "react-router-dom";

// Public Pages
import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import AdminLogin from "./pages/Admin/AdminLogin";
import OTPVerification from "./pages/OTPVerification";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ProductList from "./pages/ProductList";
import NotFound from "./pages/NotFound";

// User Pages
import ProductDetails from "./pages/ProductDetails";
import Profile from "./pages/Profile";
import ContactUs from "./pages/ContactUs";
import BasketPage from "./pages/BasketPage";
import Wallet from "./pages/Wallet";
import CustomerSubscriptions from "./pages/CustomerSubscriptions";
import EditProfile from "./pages/EditProfile";
import OrderHistory from "./pages/OrderHistory";

// Admin Pages
import Products from "./pages/Admin/AdminProducts";
import Orders from "./pages/Admin/Orders";
import AdminUsers from "./pages/users/AdminUsers";
import CouponManagement from "./pages/coupon-management";
import AppSettings from "./pages/app-settings";
import Category from "./pages/Admin/Category/index";
import GlobalNotifications from "./pages/Admin/GlobalNotifications";
import AdminWallet from "./pages/Admin/AdminWallet";
import ProductImages from "./pages/Admin/ProductImages";
import UpdateUserCartItem from "./pages/Admin/UpdateUserCartItem";
import PendingSubscribedCartItems from "./pages/Admin/PendingSubscribedCartItems";

// Route Guards
import ProtectedRoute from "./ProtectedRoute";
import AdminProtectedRoute from "./AdminProtectedRoute";

import "./index.css";
import KRProductList from "./pages/Admin/KrMarketPrice";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/otp-verification" element={<OTPVerification />} />
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/productList" element={<ProductList />} />
        <Route path="/productListKR" element={<KRProductList />} />
        <Route
          path="/adminProduct"
          element={
            <AdminProtectedRoute>
              <Products />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/adminOrders"
          element={
            <AdminProtectedRoute>
              <Orders />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/adminUsers"
          element={
            <AdminProtectedRoute>
              <AdminUsers />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/adminCoupons"
          element={
            <AdminProtectedRoute>
              <CouponManagement />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/categories"
          element={
            <AdminProtectedRoute>
              <Category />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/appSettings"
          element={
            <AdminProtectedRoute>
              <AppSettings />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/globalNotifications"
          element={<AdminProtectedRoute><GlobalNotifications /></AdminProtectedRoute>}
        />
        <Route
          path="/updateUserCartItem"
          element={
            <AdminProtectedRoute>
              <UpdateUserCartItem />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/pending-subscribed-cart-items"
          element={
            <AdminProtectedRoute>
              <PendingSubscribedCartItems />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/adminProductImages"
          element={
            <AdminProtectedRoute>
              <ProductImages />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/adminWallet"
          element={
            <AdminProtectedRoute>
              <AdminWallet />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/product/:productId"
          element={<ProductDetails />}
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <ContactUs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/basket"
          element={
            <ProtectedRoute>
              <BasketPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription"
          element={
            <ProtectedRoute>
              <CustomerSubscriptions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <ProtectedRoute>
              <EditProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute>
              <OrderHistory />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;